import React from "react";
import { classNames } from "maven-lib/dist/utils/misc";

interface HbProgressBarProps {
  className?: string;
  value?: number;
}

export function HbProgressBar(props: HbProgressBarProps) {
  const { className, value } = props;
  const percent = Math.min(parseInt(String(value || 0), 10), 100);

  return (
    <>
      <div className={classNames("hb-progress-bar", className, percent < 10 && "--under-10p", percent >= 50 && "--over-half")}>
        <i style={{ width: `${percent}%` }}>
          <strong>
            <span>{percent}%</span>
          </strong>
        </i>
      </div>
    </>
  );
}
